export default "__VITE_ASSET__Cyn3k9Vo__"